/**
 * Linear blend of two binary masks, then threshold at 0.5 (for morph animation).
 */

/**
 * @param {Uint8Array} maskA - 0/1 values
 * @param {Uint8Array} maskB - same length as maskA
 * @param {number} t - 0..1
 * @returns {Uint8Array}
 */
export function blendMasksThreshold(maskA, maskB, t) {
  const n = maskA.length;
  const out = new Uint8Array(n);
  const ta = 1 - t;
  for (let i = 0; i < n; i += 1) {
    const v = maskA[i] * ta + maskB[i] * t;
    out[i] = v >= 0.5 ? 1 : 0;
  }
  return out;
}
